<ngx-loading-bar color="#467ec0" height="4px"></ngx-loading-bar>
<router-outlet></router-outlet>
